import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faSpinner } from "@fortawesome/free-solid-svg-icons";
import "./QrCamera.css";

export interface QrCameraProps {
  cameraActive: boolean;
  scanning: boolean;
  processing: boolean;
  error: string | null;
  videoRef: React.RefObject<HTMLVideoElement | null>;
  canvasRef: React.RefObject<HTMLCanvasElement | null>;
  onStart: () => void;
  onStop: () => void;
  onRetry: () => void;
}

const QrCamera: React.FC<QrCameraProps> = ({
  cameraActive,
  scanning,
  processing,
  error,
  videoRef,
  canvasRef,
  onStart,
  onStop,
  onRetry,
}) => {
  return (
    <div className="qr-camera-container">
      <video
        ref={videoRef}
        className="qr-camera-video"
        playsInline
        muted
        style={{ display: cameraActive ? "block" : "none" }}
      ></video>
      <canvas ref={canvasRef} style={{ display: "none" }}></canvas>

      {/* Overlay for camera not active */}
      {!cameraActive && !error && !scanning && (
        <div className="qr-camera-overlay">
          <div className="qr-camera-target">
            <div className="qr-camera-placeholder">
              <FontAwesomeIcon icon={faCamera} className="qr-camera-icon" />
            </div>
          </div>
        </div>
      )}

      {/* Overlay for initializing */}
      {!cameraActive && scanning && (
        <div className="qr-camera-initializing">
          <FontAwesomeIcon icon={faSpinner} className="qr-camera-spin" size="2x" />
          <p>Initializing camera...</p>
        </div>
      )}

      {/* Overlay for processing */}
      {processing && (
        <div className="qr-camera-initializing">
          <FontAwesomeIcon icon={faSpinner} className="qr-camera-spin" size="2x" />
          <p>Processing QR code...</p>
        </div>
      )}

      {/* Overlay for error */}
      {error && (
        <div className="qr-camera-error">
          <p>{error}</p>
          <button className="qr-camera-retry-btn" onClick={onRetry}>
            Retry
          </button>
        </div>
      )}

      {/* Camera controls */}
      <div className="qr-camera-controls">
        {!scanning ? (
          <button className="qr-camera-scan-btn" onClick={onStart} disabled={processing}>
            Start Scanning
          </button>
        ) : (
          <button
            className="qr-camera-stop-btn"
            onClick={onStop}
            disabled={processing || (!cameraActive && scanning)}
          >
            {(!cameraActive && scanning) ? "Initializing..." : "Pause Scanning"}
          </button>
        )}
      </div>
    </div>
  );
};

export default QrCamera;
